<template>
  <!-- 劳务人员选择组件，只支持选择一个劳务人员 -->
  <div class="laborer-selector-area" v-if="!hasSelfSlot" @click="toSelectLaborer">
    <span class="prefix-slot" :style="{'display': hasPrefix ? 'inline-block' : 'none'}"><slot name="prefix"></slot></span>
    <span class="text" v-if="currentLaborer.contractName">{{currentLaborer.contractName}}</span>
    <span class="text holder" v-else>{{placeholder}}</span>
    <yq-icon class="icon-close" name="element-ui_close" @click.stop="clearData"/>
  </div>
  <slot>

  </slot>
  <el-dialog v-model="showSelectLaborer" title="选择一个劳务人员" dialog-width="3" append-to-body>
    <dialog-table>
      <separate-page :show-shadow="false" :show-border="true">
        <template #category>
          <el-tree :data="jobTree" :props="{children: 'children', label: 'dictName'}" @node-click="clickJob" empty-text="工种为空" node-key="dictCode" default-expand-all :expand-on-click-node="false">
            <template #default="{node}">
              <span class="custom-tree-node">
              <span class="node-name">{{ node.label }}</span>
            </span>
            </template>
          </el-tree>
        </template>
        <template #default>
          <list-page :show-shadow="false" :show-border="false">
            <search-condition :show-shadow="false">
              <template #default>
                <el-input v-model="searchInfo.contractName" placeholder="请输入姓名/手机号" @keydown.enter="resetSearch">
                  <template #prefix>查询</template>
                </el-input>
                <el-select v-model="searchInfo.classmateId" placeholder="请选择班组" clearable filterable>
                  <template #prefix>班组</template>
                  <el-option v-for="item in classmateList" :key="item.id" :value="item.id" :label="item.classmateName"></el-option>
                </el-select>
              </template>
              <template #option>
                <page-button type="read" el-type="primary" @click="resetSearch">查询</page-button>
              </template>
            </search-condition>
            <table-list>
              <yq-table :data="laborerList" border>
                <yq-table-column label="姓名" prop="contractName" :show-overflow-tooltip="true" fixed="left"/>
                <yq-table-column label="联系方式" prop="phone" :show-overflow-tooltip="true" align="center"/>
                <yq-table-column label="班组" prop="classmateName" :show-overflow-tooltip="true" align="center"/>
                <yq-table-column label="工种" prop="jobCategory" :show-overflow-tooltip="true" align="center">
                  <template v-slot="{row}">{{ jobCategoryMap[row.jobCategory] || row.jobCategory || '' }}</template>
                </yq-table-column>
                <yq-table-column label="操作" align="center" width="60rem" fixed="right">
                  <template v-slot="{row}">
                    <table-button @click="selectLaborer(row)">选择</table-button>
                  </template>
                </yq-table-column>
              </yq-table>
            </table-list>
            <form-page :show-shadow="false" v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize" :total-count="searchInfo.totalCount" @onLoad="queryList"/>
          </list-page>
        </template>
      </separate-page>
    </dialog-table>
  </el-dialog>
  
</template>

<script>
import {getCurrentInstance, watch} from "vue";
import DialogTable from "@/components/h5/layout/DialogTable.vue";
import SeparatePage from "@/components/h5/layout/SeparatorPage.vue";
import ListPage from "@/components/h5/layout/ListPage.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import TableList from "@/components/h5/layout/ListTable.vue";
import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import PageButton from "@/components/h5/button/PageButton.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import YqIcon from "@/components/YqIcon.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import commonApi from "@/api/commonApi";
import contractWorkersApi from "@/api/dz-luqiao/contractWorkersApi";
import Util from "@/util/util";
import commonLqApi from "@/api/dz-luqiao/luqiaoCommonApi";

export default {
  emits: ["change"],
  props: {
    modelValue: {default: ""},
    placeholder: {default: "请选择劳务人员"},
  },
  name: "LaborerSelect",
  components: {
    YqTableColumn,
    YqIcon,
    TableButton,
    PageButton, SearchCondition,
    DialogTable, SeparatePage, ListPage, FormPage, TableList
  },
  data() {
    return {
      currentLaborer: {}, // 当前选中的劳务人员
      showSelectLaborer: false,
      hasSelfSlot: false,
      laborerList: [], // 后台查询的劳务人员
      searchInfo: {},
      jobTree: [],
      hasPrefix: false,
      jobCategoryMap: {},
      classmateList: [],
    };
  },
  async created() {
    this.classmateList = await commonLqApi.queryClassmateNoPage(); // 施工班组
    // 是否设置了自定义的slot
    const ins = getCurrentInstance();
    if (ins && ins.slots.default) {
      const slotContent = ins.slots.default();
      this.hasSelfSlot = slotContent && slotContent.length > 0;
    }
    if (ins && ins.slots.prefix) {
      const prefixContent = ins.slots.prefix();
      this.hasPrefix = prefixContent && prefixContent.length > 0;
    }
    await this.queryJobCategoryTree();
    this.initData();
    watch(() => this.modelValue, () => this.initData())
  },
  methods: {
    // 清空数据
    clearData() {
      this.currentLaborer = {};
      this.$emit("update:modelValue", "");
      this.$emit("change", {});
    },
    async queryJobCategoryTree() {
      const user = await Util.getUserInfo();
      const list = await commonApi.queryDictionaryList("JOB_CATEGORY", user.merchantId);
      // 平铺字典转为树（一级）
      const children = (list || []).map(d => ({...d, children: []}));
      this.jobTree = [{dictName: "全部", dictCode: "", children}];
      // 构造映射
      const map = {};
      children.forEach(d => { map[d.dictCode] = d.dictName; });
      this.jobCategoryMap = map;
    },
    // 初始化页面的数据
    async initData() {
      if (!this.modelValue) {
        this.currentLaborer = {};
        return;
      }
      // 通过列表接口按id精确查询一条（若有专门findById可替换）
      const res = await contractWorkersApi.list({id: this.modelValue, pageNumber: 1, pageSize: 1});
      const row = (res && res.records && res.records[0]) || {};
      this.currentLaborer = row;

    },
    // 选择一个劳务人员
    toSelectLaborer() {
      this.showSelectLaborer = true;
      if (!this.laborerList || this.laborerList.length === 0) {
        this.resetSearch();
      }
    },
    selectLaborer(data) {
      this.currentLaborer = data;
      this.showSelectLaborer = false;
      this.$emit("update:modelValue", data.id);
      this.$emit("change", data);
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    async queryList() {
      const {records, total} = await contractWorkersApi.list(this.searchInfo)
      this.laborerList = records;
      this.searchInfo.totalCount = total;
    },
    clickJob(data) {
      // 查询工种下人员
      this.searchInfo.jobCategory = data.dictCode;
      this.resetSearch();
    },
  }
};
</script>

<style lang="scss" scoped>
.laborer-selector-area{
  display: inline-flex;
  vertical-align: top;
  width: 100%;
  border: 0.05333rem solid var(--yq-border-color);
  box-sizing: border-box;
  padding: 0 10px;
  border-radius: 4px;
  color: var(--el-color-info-dark-2);
  white-space: nowrap;
  position: relative;
  .prefix-slot:after{
    content: ":";
  }
  .text{
    display: inline-block;
    width: 100%;
  }
  .holder{
    color: var(--el-color-info-light-3);
  }
  .icon-close{
    display: none;
    position: absolute;
    font-size: 8px;
    width: 10px;
    height: 10px;
    line-height: 10px;
    border-radius: 10px;
    border: 1px solid var(--el-color-info);
    right: 10px;
    top: 10px;
    color: var(--el-color-info);
    cursor: pointer;
  }
}
.laborer-selector-area:hover{
  .icon-close{
    display: block;
    text-align: center;
    align-items: center;
  }
}
</style>


